const WeatherImageUrls = new Map();

WeatherImageUrls.set(
	'rain>90',
	'https://d1fcioetl6if2w.cloudfront.net/fmtapp/asset/rainfall___90.riv',
);
WeatherImageUrls.set(
	'rain70-30',
	'https://d1fcioetl6if2w.cloudfront.net/fmtapp/asset/rainfall_is_30-70.riv',
);
WeatherImageUrls.set(
	'rain90-70',
	'https://d1fcioetl6if2w.cloudfront.net/fmtapp/asset/rainfall_70-90.riv',
);
WeatherImageUrls.set(
	'wind>25',
	'https://d1fcioetl6if2w.cloudfront.net/fmtapp/asset/wind_speed___25.riv',
);
WeatherImageUrls.set(
	'wind25-12',
	'https://d1fcioetl6if2w.cloudfront.net/fmtapp/asset/wind_speed_12.5-25.riv',
);
WeatherImageUrls.set(
	'lowTemprature',
	'https://d1fcioetl6if2w.cloudfront.net/fmtapp/asset/low_temperature.riv',
);
WeatherImageUrls.set(
	'highTemprature',
	'https://d1fcioetl6if2w.cloudfront.net/fmtapp/asset/high_temperature_(max_t___35).riv',
);
WeatherImageUrls.set(
	'noLocation',
	'https://d1fcioetl6if2w.cloudfront.net/fmtapp/asset/no_location.riv',
);
WeatherImageUrls.set(
	'normalWeather',
	'https://d1fcioetl6if2w.cloudfront.net/fmtapp/asset/normal_weather.riv',
);

export default WeatherImageUrls;
